import { Box, Stack } from '@mui/material';
import { DuplicateCard } from './DuplicateCard';
import { NavigationControls } from './NavigationControls';

export const DuplicatesListView = ({ 
    currentGroup,
    currentIndex,
    totalGroups,
    selectedIndex,
    onSelectDuplicate,
    onPrevious,
    onNext,
    renderDetails,
    fascicoliByAnagraficaId // Nuova prop: mappa anagraficaId -> fascicoli
}) => {
    // Determina se c'è una selezione attiva
    const hasSelection = selectedIndex !== null && selectedIndex !== undefined;
    
    return (
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            {/* Card dei duplicati in colonna con scroll verticale */}
            <Box 
                sx={{ 
                    flex: 1,
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    pr: 1,
                    mb: 2,
                    '&::-webkit-scrollbar': {
                        width: '8px',
                    },
                    '&::-webkit-scrollbar-track': {
                        backgroundColor: '#f1f1f1',
                        borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: '#888',
                        borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                        backgroundColor: '#555',
                    },
                }}
            >
                <Stack direction="column" spacing={2}>
                    {currentGroup.duplicates.map((duplicate, idx) => {
                        // Recupera i fascicoli per questa anagrafica
                        const fascicoli = fascicoliByAnagraficaId?.[duplicate.id] || [];
                        
                        return (
                            <DuplicateCard
                                key={duplicate.id}
                                duplicate={duplicate}
                                idx={idx}
                                isSelected={selectedIndex === idx}
                                onSelect={() => onSelectDuplicate(idx)}
                                renderDetails={renderDetails}
                                hasSelection={hasSelection}
                                totalDuplicates={currentGroup.duplicates.length}
                                fascicoli={fascicoli}
                            />
                        );
                    })}
                </Stack>
            </Box>
            
            {/* Contatore e navigazione - sempre visibile in basso */}
            <Box sx={{ flexShrink: 0 }}>
                <NavigationControls
                    currentIndex={currentIndex}
                    totalItems={totalGroups}
                    onPrevious={onPrevious}
                    onNext={onNext}
                />
            </Box>
        </Box>
    );
};
